import React from 'react';
import styled from 'styled-components';

interface Props {
	maxvalue: number;
	value: number;
	color: string;
	additionalText: string;
}

const Background = styled.div`
	width: 100%;
	height: 8px;
	background-color: #E5E5E5;
	margin: auto;
`;

const Filler = styled.div<{ color?: string, val: string }>`
	height: 8px;
	background-color: ${props => props.color || 'red'};
	width: ${props => props.val};
	max-width: 100%;
`;

const AdditionalText = styled.div`
	font-size: 1.25em;
`;

export const LineMeter: React.FC<Props> = (props: Props) => {
	const result = props.value / props.maxvalue;
	const percent = result * 100;
	return (
		<div>
			<Background>
				<Filler val={`${percent.toString()}%`} color={props.color} >
				</Filler>
			</Background>
			{props.additionalText && (
				<AdditionalText>
					<h5>{props.additionalText}</h5>
				</AdditionalText>
			)}
		</div>
	);
};
